import { render, staticRenderFns } from "./BodyDeRecebimentos.vue?vue&type=template&id=75bac9a8&scoped=true"
import script from "./BodyDeRecebimentos.vue?vue&type=script&setup=true&lang=js"
export * from "./BodyDeRecebimentos.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BodyDeRecebimentos.vue?vue&type=style&index=0&id=75bac9a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75bac9a8",
  null
  
)

export default component.exports